import { ApiResponse } from 'src/app/shared/types/api-responses.type';

export class GetSummaryWithWeeklyTrendRequestParams {
  merchantCode: string | undefined = undefined;
  providerCode: string | undefined = undefined;
}

export interface TransactionDetailSummaryByStatus {
  status: string;
  description: string;
  total_today: number;
  total_week: number;
  total_month: number;
  total_year: number;
  amount_today: number;
  amount_week: number;
  amount_month: number;
  amount_year: number;
}

export type SummaryPeriod = 'today' | 'week' | 'month' | 'year';

export interface SuccessTransactionDetailDay {
  date: string; // format: YYYY-MM-DD
  day_name: string; // e.g., "Monday"
  total_success: number;
}

export interface SuccessThisAndLastWeek {
  this_week: SuccessTransactionDetailDay[];
  last_week: SuccessTransactionDetailDay[];
}

export class TransactionDetailSummaryResult {
  summary_transaction_detail_by_status: TransactionDetailSummaryByStatus[] = [];
  success_transaction_detail_this_and_last_week: SuccessThisAndLastWeek = {
    this_week: [],
    last_week: [],
  };
}

export type GetSummaryWithWeeklyTrendResponse = ApiResponse<TransactionDetailSummaryResult>;
